import { createPostPageController } from '../../external/post-page/controller';

export default createPostPageController;
